<div class="loading-screen-wrapper" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
